import type { ReactNode } from 'react';

import { SurfaceStyled } from './card-surface.styled';

type CardSurfaceProps = {
  children?: ReactNode;
};

export const CardSurface = (props: CardSurfaceProps) => {
  const { children } = props;

  return <SurfaceStyled>{children}</SurfaceStyled>;
};
